import { Component, OnInit, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { Subscription } from "rxjs";
import { Organization } from "../../../common/models/organization.model";
import { NavigationReference } from "../../../common/models/navigationreference.model";
import { Module } from "../../../common/models/module.model";
import { FlowOnBehalfService } from "../../../flow/services/flow-on-behalf.service";
import { OnBehalfSteps } from "../../models/on-behalf.model";
import { LoaderService } from "../../../common/services/loader.service";

@Component({
    selector: 'on-behalf-generate-application',
    templateUrl: './on-behalf-generate-application.component.html',
    styleUrls: ['./on-behalf-generate-application.component.scss'],
    standalone: false
})
export class OnBehalfGenerateApplicationComponent implements OnInit, OnDestroy {

    @Output() applicationGenerated: EventEmitter<string> = new EventEmitter<string>();
    @Output() nextStep: EventEmitter<OnBehalfSteps> = new EventEmitter<OnBehalfSteps>();
    @Input() applicationModule: Module;
    applicationNumber: string;
    get applicationNumberGenerated(): boolean {
        return this.applicationNumber != null && this.applicationNumber !== "";
    }
    @Input() applicationType: NavigationReference;
    @Input() organization: Organization;

    subscription: Subscription = new Subscription();

    @Output() throwError: EventEmitter<string> = new EventEmitter<string>();

    constructor(private readonly onBehalfService: FlowOnBehalfService,
        private readonly loader: LoaderService
    ) { }

    ngOnInit() {
        
    }


    ngOnDestroy() {
        if (this.subscription) this.subscription.unsubscribe();
    }


    advance() {
        this.nextStep.emit(OnBehalfSteps.GenerateScanAndSubmit);
    }

    generateApplication(): void {
        let templateId = this.applicationType.uriComponent;
        this.loader.toggleLoader(true);
        let appSubs$ = this.onBehalfService.generateIdentifierForTemplate(templateId).pipe().subscribe(
            (app) => {
                this.applicationNumber = app;  
                this.loader.toggleLoader(false);
                this.applicationGenerated.emit(this.applicationNumber);                
            }, (error) => {
                console.error(error);
                this.loader.toggleLoader(false);
                this.throwError.emit(error);
            });
        this.subscription.add(appSubs$);
    }
}
